import {
  PayoutOrderActionButton,
  PayoutOrderAction,
  PayoutOrderColumnProperties,
  PayoutOrderListItem,
} from '@/models/payout-order/payout-order-list.model';
import { AlignOptions } from '@/models/common/align-options.model';
import { TableColumn } from '@/models/common/table.model';

export const payoutOrderColumnLabel: Record<string, string> = {
  [PayoutOrderColumnProperties.CREATED_AT]: 'Time passed',
  [PayoutOrderColumnProperties.WHITELABEL_SLUG]: 'Brand',
  [PayoutOrderColumnProperties.PLAYER]: 'Player',
  [PayoutOrderColumnProperties.MODERATE_BACK_OFFICE_ADMIN_EMAIL]: 'Assignment',
  [PayoutOrderColumnProperties.AMOUNT]: 'Amount',
  [PayoutOrderColumnProperties.PSP]: 'PSP',
  [PayoutOrderColumnProperties.PROCESSING_TYPE]: 'Processing type',
  [PayoutOrderColumnProperties.TRANSACTION_STATUS]: 'Status',
  [PayoutOrderColumnProperties.ACTIONS]: 'Actions',
};

export const payoutOrderColumnsList: Array<TableColumn<PayoutOrderListItem>> = [
  {
    label: payoutOrderColumnLabel[PayoutOrderColumnProperties.CREATED_AT],
    prop: PayoutOrderColumnProperties.CREATED_AT,
    width: 100,
  },
  {
    label: payoutOrderColumnLabel[PayoutOrderColumnProperties.WHITELABEL_SLUG],
    prop: PayoutOrderColumnProperties.WHITELABEL_SLUG,
    formatter: (row: PayoutOrderListItem) => row[PayoutOrderColumnProperties.WHITELABEL_SLUG].toUpperCase(),
    width: 150,
  },
  {
    label: payoutOrderColumnLabel[PayoutOrderColumnProperties.PLAYER],
    prop: PayoutOrderColumnProperties.PLAYER_EMAIL,
    minWidth: 200,
  },
  {
    label: payoutOrderColumnLabel[PayoutOrderColumnProperties.MODERATE_BACK_OFFICE_ADMIN_EMAIL],
    prop: PayoutOrderColumnProperties.MODERATE_BACK_OFFICE_ADMIN_EMAIL,
    minWidth: 200,
  },
  {
    label: payoutOrderColumnLabel[PayoutOrderColumnProperties.AMOUNT],
    prop: PayoutOrderColumnProperties.AMOUNT,
    width: 100,
  },
  {
    label: payoutOrderColumnLabel[PayoutOrderColumnProperties.PSP],
    prop: PayoutOrderColumnProperties.PSP,
    width: 110,
  },
  {
    label: payoutOrderColumnLabel[PayoutOrderColumnProperties.PROCESSING_TYPE],
    prop: PayoutOrderColumnProperties.PROCESSING_TYPE,
    width: 90,
  },
  {
    label: payoutOrderColumnLabel[PayoutOrderColumnProperties.TRANSACTION_STATUS],
    prop: PayoutOrderColumnProperties.TRANSACTION_STATUS,
    width: 130,
    align: AlignOptions.CENTER,
  },
  {
    label: payoutOrderColumnLabel[PayoutOrderColumnProperties.ACTIONS],
    prop: PayoutOrderColumnProperties.ACTIONS,
    width: 120,
    fixed: 'right',
    align: AlignOptions.CENTER,
  },
];

export const payoutOrderActionMap: Record<PayoutOrderAction, PayoutOrderActionButton> = {
  [PayoutOrderAction.TAKE]: {
    label: 'Take',
    type: 'success',
  },
  [PayoutOrderAction.DROP]: {
    label: 'Drop',
    type: 'danger',
  },
  [PayoutOrderAction.MANUAL_FLOW]: {
    label: 'Manual flow',
    type: 'danger',
  },
  [PayoutOrderAction.FORCE_TAKE]: {
    label: 'Force take',
    type: 'danger',
  },
};
